import * as Yup from "yup";


export const deliveryMethodValidations = (section, languageText) => {

    if (section.active) {
        return Yup.object().shape({
            // deliveryMethodGroup: Yup.array()
            releasemodePdf: Yup.string()
                .required(
                    () =>
                        true &&
                        languageText.ErrorChecking.ValidatorText.MissingDelivery
                ),
        })
    } else { return Yup.object().shape(); }
}
